import {  getNavMenu, getNavRestrictions } from "api/auth";
import { useQuery } from "react-query";

export const tabList = [
  {
    key: 1,
    name: "Home",
    view: "home",
    route: "/home",
  },
  {
    key: 2,
    name: "People",
    view: "people",
    route: "/people",
  },
  {
    key: 3,
    name: "Time-off",
    view: "timeoff",
    route: "/timeoffs",
  },
  {
    key: 4,
    name: "Training",
    view: "trainings",
    route: "/trainings",
  },
  {
    key: 5,
    name: "Benefits",
    view: "benefits",
    route: "/benefits",
  },
  {
    key: 6,
    name: "Documents",
    view: "documents",
    route: "/documents",
  },
  {
    key: 7,
    name: "Tasks",
    view: "tasks",
    route: "/tasks",
  },
  {
    key: 8,
    name: "Attendance",
    view: "attendance",
    route: "/attendance",
  },
  {
    key: 9,
    name: "Shift Rota",
    view: "shift",
    route: "/shift",
  },
  {
    key: 10,
    name: "Payslips",
    view: "payslips",
    route: "/payslips",
  },
  {
    key: 11,
    name: "Performance Review",
    view: "performance",
    route: "/performance",
  },
  {
    key: 12,
    name: "Settings",
    view: "settings",
    route: "/settings",
  },
];


const useNavRestrictions = () => {
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");

 
  const navRestrictionQuery = useQuery(
    "nav-restriction-query",
    getNavRestrictions
  );
  const navMenuQuery = useQuery(
    "nav-menu-query",
    () => getNavMenu(user?.id)
  );


  const { data = [] } = navRestrictionQuery;
  const { data: menuData ={}} = navMenuQuery;

  // const allowTabs =
  //   data?.map((tab) => {
  //     const tabData =
  //       tabList.find((item) =>
  //         item.name.toLowerCase().includes(tab.name.toLowerCase())
  //       ) || {};

  //     return { ...tab, ...tabData };
  //   }) || [];
  // return {
  //   ...navRestrictionQuery,
  //   tabList: allowTabs,
  //   // tabList: tabList,
  // };


const defaultTabs = ['home','people', 'task', 'setting'];

const allowTabs =
  data
    ?.filter((tab) => {
      const tabCode = tab.code?.toLowerCase();

   
      if (defaultTabs.includes(tabCode)) return true;

     
      return menuData[tabCode] === true;
    })
    .map((tab) => {
      const tabData =
        tabList.find((item) =>
          item.name.toLowerCase().includes(tab.name.toLowerCase())
        ) || {};
      return { ...tab, ...tabData };
    }) || [];
   return {
    ...navRestrictionQuery,
    tabList: allowTabs,
  };
  
};

export default useNavRestrictions;
